// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-multiline-autocomplete {
  margin-top: 2px;
  padding: 2px;
  position: relative;
  background-color: #222;
}

.neuroglancer-multiline-autocomplete-hint,
.neuroglancer-multiline-autocomplete-input {
  font-family: monospace;
  color: #fff;
  word-wrap: break-word;
}

.neuroglancer-multiline-autocomplete-input:focus {
  outline: 0px;
}

.neuroglancer-multiline-autocomplete-input:not(:focus):empty::before {
  content: attr(data-placeholder);
  color: #aaa;
}

.neuroglancer-multiline-autocomplete-hint {
  color: #aaa;
}

.neuroglancer-multiline-autocomplete-hint,
.neuroglancer-multiline-autocomplete-input,
.neuroglancer-multiline-autocomplete-completion {
  font-family: monospace;
  font-size: medium;
}

.neuroglancer-multiline-autocomplete-dropdown,
.neuroglancer-multiline-autocomplete-error,
.neuroglancer-multiline-autocomplete-progress {
  background-color: #181818;
  position: fixed;
  display: block;
  outline: 0;
  margin: 0;
  padding: 0;
  left: 0px;
  right: 0px;
  text-align: left;
  cursor: default;
  border-style: solid;
  border-width: 1px;
  border-color: #aaa;
  overflow-y: scroll;
  word-wrap: break-word;
}

.neuroglancer-multiline-autocomplete-dropdown {
  color: #fff;
}

.neuroglancer-multiline-autocomplete-error {
  color: red;
}

.neuroglancer-multiline-autocomplete-progress {
  font-style: italic;
  color: #ccc;
}

.neuroglancer-multiline-autocomplete-completion:nth-child(even):not(
    .neuroglancer-multiline-autocomplete-completion-active
  ) {
  background-color: #2b2b2b;
}

.neuroglancer-multiline-autocomplete-completion:hover {
  outline: 1px solid #ddd;
}

.neuroglancer-multiline-autocomplete-completion-active {
  background-color: #666;
}

.neuroglancer-multiline-autocomplete-completion-with-description {
}

.neuroglancer-multiline-autocomplete-completion-description {
  font-style: italic;
  color: #f9f;
}

.neuroglancer-multiline-autocomplete-linebreak::after {
  content: "\\a";
  white-space: pre;
}
`, "",{"version":3,"sources":["webpack://./node_modules/neuroglancer/lib/widget/multiline_autocomplete.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;EAGE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,UAAU;EACV,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["/**\n * @license\n * Copyright 2016 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-multiline-autocomplete {\n  margin-top: 2px;\n  padding: 2px;\n  position: relative;\n  background-color: #222;\n}\n\n.neuroglancer-multiline-autocomplete-hint,\n.neuroglancer-multiline-autocomplete-input {\n  font-family: monospace;\n  color: #fff;\n  word-wrap: break-word;\n}\n\n.neuroglancer-multiline-autocomplete-input:focus {\n  outline: 0px;\n}\n\n.neuroglancer-multiline-autocomplete-input:not(:focus):empty::before {\n  content: attr(data-placeholder);\n  color: #aaa;\n}\n\n.neuroglancer-multiline-autocomplete-hint {\n  color: #aaa;\n}\n\n.neuroglancer-multiline-autocomplete-hint,\n.neuroglancer-multiline-autocomplete-input,\n.neuroglancer-multiline-autocomplete-completion {\n  font-family: monospace;\n  font-size: medium;\n}\n\n.neuroglancer-multiline-autocomplete-dropdown,\n.neuroglancer-multiline-autocomplete-error,\n.neuroglancer-multiline-autocomplete-progress {\n  background-color: #181818;\n  position: fixed;\n  display: block;\n  outline: 0;\n  margin: 0;\n  padding: 0;\n  left: 0px;\n  right: 0px;\n  text-align: left;\n  cursor: default;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #aaa;\n  overflow-y: scroll;\n  word-wrap: break-word;\n}\n\n.neuroglancer-multiline-autocomplete-dropdown {\n  color: #fff;\n}\n\n.neuroglancer-multiline-autocomplete-error {\n  color: red;\n}\n\n.neuroglancer-multiline-autocomplete-progress {\n  font-style: italic;\n  color: #ccc;\n}\n\n.neuroglancer-multiline-autocomplete-completion:nth-child(even):not(\n    .neuroglancer-multiline-autocomplete-completion-active\n  ) {\n  background-color: #2b2b2b;\n}\n\n.neuroglancer-multiline-autocomplete-completion:hover {\n  outline: 1px solid #ddd;\n}\n\n.neuroglancer-multiline-autocomplete-completion-active {\n  background-color: #666;\n}\n\n.neuroglancer-multiline-autocomplete-completion-with-description {\n}\n\n.neuroglancer-multiline-autocomplete-completion-description {\n  font-style: italic;\n  color: #f9f;\n}\n\n.neuroglancer-multiline-autocomplete-linebreak::after {\n  content: \"\\a\";\n  white-space: pre;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
